import React from "react";
import {AuthManagerAdmin, AuthStudent, AuthSuperAdmin, AuthTeacher} from "../api";
import Layout from "../components/Layout";
import {StudentUrls} from "./Student";
import {TeacherUrls} from "./Teacher";

export interface Url {
    Uri: string,
    Comp: React.ComponentType,
    Auth: number[],
    Layout: boolean;
}


//page

export const NewComponent = (u: Url): JSX.Element => {
    if (u.Layout) {
        return (
            <Layout>
                <u.Comp/>
            </Layout>
        );
    }
    return <u.Comp/>;
};

const Home = React.lazy(
    () => import('../pages/Home/Home'))

const Manager = React.lazy(
    () => import('../pages/Admin/Manager'))
const Login = React.lazy(
    () => import("../pages/Auth/Login"))

const ResetInitPassword = React.lazy(() => import('../pages/Auth/ResetInitPassword'))


const FileLog = React.lazy(
    () => import("../pages/Admin/file_log"))

const Dashboard = React.lazy(
    () => import('../pages/Dashboard/Dashboard'))




export const adminUrls: Url[] = [
    {Uri: "/admin/manager", Comp: Manager, Auth: [AuthManagerAdmin, AuthSuperAdmin], Layout: true},
    {Uri: "/admin/file_log", Comp: FileLog, Auth: [AuthSuperAdmin], Layout: true},
]


export const AuthsUrls: Url[] = [
    {Uri: "/login", Comp: Login, Auth: [], Layout: true},
    {Uri: "/reset-init-password", Comp: ResetInitPassword, Auth: [], Layout: true},
    {Uri: "/", Comp: Home, Auth: [], Layout: false},
    {Uri: "/home", Comp: Home, Auth: [], Layout: false},
    {Uri: "/index", Comp: Home, Auth: [], Layout: false},

    {Uri: "/dashboard", Comp: Dashboard, Auth: [AuthTeacher], Layout: true},
    ...TeacherUrls,
    ...adminUrls,
    ...StudentUrls,
]